(function () {
    'use strict';

    function findAPartnerService() {
        var currentPartnerType = null;
        var findAnEntityOptions = {};

        function setPartnerType(partnerType) {
            currentPartnerType = partnerType;
        }

        function getPartnerType() {
            return currentPartnerType;
        }

        function getFindAnEntityOptions() {
            return findAnEntityOptions;
        }

        function setFindAnEntityOptions(newFindAnEntityOptions) {
            findAnEntityOptions = newFindAnEntityOptions;
        }

        return {
            getPartnerType: getPartnerType,
            setPartnerType: setPartnerType,
            getFindAnEntityOptions: getFindAnEntityOptions,
            setFindAnEntityOptions: setFindAnEntityOptions
        };
    }

    findAPartnerService.$inject = [];

    angular.module('ecap.common').service('findAPartnerService', findAPartnerService);
})();